import * as React from 'react';
import { Textarea } from 'ui';
import { SHORT_DEBOUNCE_TIME } from 'app/components/translation/constants';
import { createExcelMappingFieldId } from '../utils/map-company-report';
import { ExcelMappingsTextProps } from '../types';

export const ExcelMappingsText = (props: ExcelMappingsTextProps) => {
  const { id, value, text, field, maxLength, placeholder, infoText,
    companyReportItem: { excelMapping } = {}
  } = props;

  const fieldId = createExcelMappingFieldId(id, field);

  const onChange = (fieldValue: string) => {
    id && excelMapping && props.updateItem({
      excelMapping: excelMapping.map(item => item?.id === id
        ? {
          ...item,
          [field]: fieldValue
        }
        : item)
    });
  };

  return <Textarea
    componentId={fieldId}
    onChange={onChange}
    value={value}
    label={{ text }}
    wait={SHORT_DEBOUNCE_TIME}
    maxLength={maxLength}
    placeholder={placeholder}
    info={infoText} />;
};
